import { KeyRound } from '@orgus/ui/icons';
import { GitHubMark } from './GitHubMark.tsx';
import { GoogleMark } from './GoogleMark.tsx';
import { MicrosoftMark } from './MicrosoftMark.tsx';

/** The mark of a sign-in provider; the owner link (or anything unknown) gets a key. */
export function ProviderMark({ id, className }: { id: string; className?: string }) {
  if (id === 'github') return <GitHubMark className={className} />;
  if (id === 'google') return <GoogleMark className={className} />;
  if (id === 'microsoft') return <MicrosoftMark className={className} />;
  return <KeyRound className={className} aria-hidden />;
}
